import { Selected } from './../../shared/components/data-table/data-table.service';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { HttpService } from 'app/shared/services/http.service';
import { SessionService } from 'app/shared/services/session.service';
import { DblinkedSessionService } from 'app/shared/services/dblinked-session.service';
import { TitleService } from 'app/shared/services/title.service';
import { ToolbarService } from 'app/shared/services/toolbar.service';
import { UtilService } from 'app/shared/services/util.service';
import { LoginService } from 'app/shared/services/login.service';
import { Message, MessageService } from 'primeng/api';
import { ToolbarButton } from '../../shared/model/toolbar-button.model';

@Component({
  selector: 'app-periodo',
  templateUrl: './periodo.component.html',
  styleUrls: ['./periodo.component.scss'],
})

export class PeriodoTransferComponent implements OnInit, OnDestroy {
  transferList: Array<any> = null;
  logAdvertencia: Message[] = null;
  existeLog: boolean;
  modalLog: boolean;
  canRemove: boolean;
  private sessionSubscription: Subscription;
  title: string;
  subtitle: string;

  constructor(private titleService: TitleService,
              private toolbarService: ToolbarService,
              private httpService: HttpService,
              private utilService: UtilService,
              private loginService: LoginService,
              private sessionService: SessionService,
              private dblinkedSessionService: DblinkedSessionService,
              private messageService: MessageService) {
  }

  ngOnInit(): void {
    this.title = 'TRANSFER PRICING - PERÍODO';
    this.subtitle = '';
    this.titleService.title = 'TRANSFER PRICING - PERÍODO';

    this.dblinkedSessionService.showPeriodsWithNextMonths(true, true, 24, 1, 2);

    this.existeLog = false;
    this.modalLog = false;

    this.sessionSubscription = this.sessionService.initSubscribe(this.dblinkedSessionService.sessionChanged,
                                                                 () => { this.sessionChange(); });
  }

  ngOnDestroy() {
    // this.toolbarService.clear();

    this.dblinkedSessionService.hidePeriods();

    this.sessionService.destroySubscribe(this.sessionSubscription);
  }

  sessionChange() {
    // this.toolbarService.clear();


    this.canRemove = false;

    if (this.dblinkedSessionService.hasEmpresaSelected && this.dblinkedSessionService.hasYearSelected) {
      this.httpService.wait();
      this.httpService.get('/tpperiodo' +
                          '?$select=dtIni,dtFin,status/id' +
                          '&$filter=empresa/id eq ' + this.dblinkedSessionService.empresa.id +
                                  ' and period(dtIni,dtFin) eq ' + this.dblinkedSessionService.periodo.year.value +
                          '&$orderby=dtIni')
                      .subscribe(cadecd => {
                                   this.transferList = cadecd.value;
                                   this.transferList.forEach(ecd => {
                                     ecd.homologado = ecd.status.id === 3;
                                     ecd.apurado = ecd.homologado || ecd.status.id === 2;
                                   });
                                   console.log(cadecd);

                                   /*this.loaded();*/
                                 },
                                 error => this.httpService.handleError(error, () => this.sessionChange()),
                                 () => this.httpService.done());
    }
  }

  loaded() {
    console.log(this.transferList);
    if (this.transferList && this.transferList.length > 0) {
      // this.toolbarService.clear();
        //this.toolbarRefresh();
      if (this.existeLog) {
        this.toolbarService.alterarStatus('msg', false, 'Visualizar Log', () => this.abreModalLog());
        // this.toolbarService.add('warning', false, 'class-back-button', 'warning', 'Visualizar Log', () => this.abreModalLog());
      } else {
        this.toolbarService.alterarStatus('msg', true, 'Visualizar Log', () => this.abreModalLog());
        // this.toolbarService.add('warning', true, 'class-back-button', 'warning', 'Visualizar Log', () => this.abreModalLog());
      }
      this.toolbarService.alterarStatus('download', true, 'Download', () => this.export());
      /*this.toolbarService.add('export', true, 'class-remove-button', 'cloud_download', 'Download', () => this.export());
      this.toolbarService.add('export', true, 'class-remove-button', 'cloud_download', 'Download', () => this.export());
      this.toolbarService.add('export', true, 'class-export-button', 'description', 'Exportar', () => this.export());
      this.toolbarService.add('print', true, 'class-print-button', 'print', 'Imprimir', () => this.export());*/

      this.canRemove = false;

      if (this.canRemove) {
        this.toolbarService.alterarStatus('remove', false, 'Excluir selecionado(s)', () => this.remove());
        // this.toolbarService.add('remove', false, 'class-remove-button', 'delete', 'Excluir selecionado(s)', () => this.remove());
      } else {
        this.toolbarService.alterarStatus('remove', true, 'Excluir', () => this.remove());
        // this.toolbarService.add('remove', true, 'class-remove-button', 'delete', 'Excluir', () => this.remove());
      }
      this.toolbarService.alterarStatus('edit', true, 'Editar', () => this.export());
      // this.toolbarService.add('edit', true, 'class-edit-button', 'edit', 'Editar!', () => this.export());
      this.toolbarService.replace('add', true, 'class-new-button', 'NOVO', 'adicionar', () => this.export());
      this.toolbarService.alterarStatus('export', true, 'Download', () => this.export());
      this.onSelect();
    }
  }

  onSelect() {
    if (this.toolbarService.get('remove')) {
      this.toolbarService.get('remove').disabled = !this.hasSelected || this.hasSelectedApurado;
      this.toolbarService.get('download').disabled = !this.hasSelected || this.hasSelectedApurado;
    }
  }
  onSelectAll(checked: boolean) {
    this.transferList.forEach(ecd => {
      ecd.selected = checked;
    });
    this.onSelect();
  }

  onSelectAllStatus(undo: boolean, statusId: number) {
    let process: string;

    switch (statusId) {
      case 2:
        if (this.allApuracaoDisabled) {
          return false;
        }
        process = 'apuração';
        break;
      case 3:
        if (this.allHomologacaoDisabled) {
          return false;
        }
        process = 'homologação';
        break;
    }

    if (confirm('Deseja ' + (undo ? 'desfazer' : 'efetuar' ) + ' a ' + process + ' de todo o período?')) {
      this.httpService.wait();
      this.httpService.post('/custom/transfer/status(' + this.dblinkedSessionService.empresa.id + ',' +
                                                this.dblinkedSessionService.periodo.year.value + ',' +
                                                (undo ? statusId - 1 : statusId) + ')')
                      .subscribe(() => {
                                   this.transferList.forEach(ecd => {
                                     ecd.status.id = undo ? statusId - 1 : statusId;
                                     ecd.homologado = ecd.status.id === 3;
                                     ecd.apurado = ecd.homologado || ecd.status.id === 2;
                                   });

                                   this.onSelect();
                                 },
                                 error => this.httpService.handleError(error, () => this.onSelectAllStatus(undo, statusId)),
                                 () => this.httpService.done());

      return true;
    }

    return false;
  }

  onClick(row: any, statusId: number, disabled: boolean, event?: any) {
    if (!disabled && (!event || event.keyCode === 32)) {
      let undo: boolean;
      let process: string;

      switch (statusId) {
        case 2:
          undo = row.apurado;
          process = 'apuração';
          break;
        case 3:
          undo = row.homologado;
          process = 'homologação';
          break;
      }

      if (confirm('Deseja ' + (undo ? 'desfazer' : 'efetuar' ) + ' a ' + process + ' do período?')) {
        return true;
      }
    }

    return false;
  }

  onChange(row: any) {
    if (row.homologado) {
      row.status.id = 3;
    } else if (row.apurado) {
      row.status.id = 2;
    } else {
      row.status.id = 1;
    }



    this.httpService.wait();
    this.httpService.post('/custom/transfer/status(' + row.id + ',' + row.status.id + ')')
                    // .subscribe(() => this.onSelect(),
                    .subscribe(result => this.resultado(result),
                               error => this.httpService.handleError(error, () => this.onChange(row)),
                               () => this.httpService.done());
  }

  remove() {
    if (confirm('Deseja excluir o(s) registro(s) selecionados?')) {
      this.removeNext();
    }
  }

  resultado(result: any) {



    this.existeLog = false;

    result.forEach(element => {
      if (element.error) {
        this.logAdvertencia.push({ severity: 'warn',key: 'messageLinnks', summary: 'Advertência:', detail: element.message });
        this.existeLog = true;

        this.messageService.add({ severity: 'warn',key: 'messageLinnks', summary: 'Advertência:',
                                   detail: 'Ocorreram erros que impossibilitaram a ação, verifique os detalhes no log' });
      } else {
        this.messageService.add({ severity: 'success',key: 'messageLinnks', summary: 'Sucesso:', detail: element.message });
      }
    });

    this.sessionChange();
  }

  removeNext() {
    const ecd: any = this.transferList.find(e => e.selected);

    if (ecd) {
      this.httpService.wait();
      this.httpService.delete('/cadecd', ecd.id)
                      .subscribe(() => {
                                   this.transferList.splice(this.transferList.findIndex(e => e.selected), 1);

                                   this.onSelect();

                                   this.removeNext();
                                 },
                                 error => this.httpService.handleError(error, () => this.removeNext()),
                                 () => this.httpService.done());
    }
  }

  export() {

  }

  download(result: any) {
    if (!result.error) {
      if (!this.transferList || this.transferList.length === 0) {
        this.sessionChange();
      }

      window.open(this.httpService.url('/custom/file/' + result.file), '_blank');
    }
  }

  get selected(): Array<any> {
    if (!this.transferList) {
      return null;
    }

    return this.transferList.filter(ecd => ecd.selected);
  }

  get hasSelected(): boolean {
    return this.selected && this.selected.length > 0;
  }

  get hasNotSelected(): boolean {
    return this.transferList && this.selected && this.transferList.length === this.selected.length;
  }

  get hasSelectedApurado(): boolean {
    return this.selected && this.selected.findIndex(ecf => ecf.apurado) > -1;
  }

  get hasApurado(): boolean {
    return this.transferList && this.transferList.findIndex(ecf => ecf.apurado) > -1;
  }

  get hasNotApurado(): boolean {
    return this.transferList && this.transferList.findIndex(ecf => !ecf.apurado) > -1;
  }

  get hasAllApurado(): boolean {
    return this.hasApurado && !this.hasNotApurado;
  }

  get hasAllNotApurado(): boolean {
    return !this.hasApurado && this.hasNotApurado;
  }

  get hasHomologado(): boolean {
    return this.transferList && this.transferList.findIndex(ecf => ecf.homologado) > -1;
  }

  get hasNotHomologado(): boolean {
    return this.transferList && this.transferList.findIndex(ecf => !ecf.homologado) > -1;
  }

  get hasAllHomologado(): boolean {
    return this.hasHomologado && !this.hasNotHomologado;
  }

  get hasAllNotHomologado(): boolean {
    return !this.hasHomologado && this.hasNotHomologado;
  }

  get allApuracaoDisabled(): boolean {
    return this.hasHomologado || (this.hasApurado && !this.hasAllApurado);
  }

  get allHomologacaoDisabled(): boolean {
    return this.hasNotApurado || (this.hasHomologado && !this.hasAllHomologado);
  }

  get allApuracaoIndeterminate(): boolean {
    return this.hasApurado && !this.hasAllApurado;
  }

  get allHomologacaoIndeterminate(): boolean {
    return this.hasHomologado && !this.hasAllHomologado;
  }

  get allSelectedIndeterminate(): boolean {
    return this.hasSelected && !this.hasNotSelected;
  }

  abreModalLog() {
    this.modalLog = true;

  }

  hideMessage() {




    this.existeLog = false;
    this.loaded();
  }
  private toolbarRefresh() {
    // casos em que a toolbar vem vazia (session de outra página)
    const todos = this.buttons.slice();
      if ( todos.length === 0) {
        this.toolbarService.replace('atualizar', true, 'class-first-button', 'refresh', 'Atualizar relatório', );
        this.toolbarService.replace('msg', true, 'class-other-button', 'warning', 'Visualizar', );
        this.toolbarService.replace('pesquisa', true, 'class-first-button', 'search', 'Pesquisar', );
        this.toolbarService.replace('download', true, 'class-other-button', 'cloud_download', 'Download', );
        this.toolbarService.replace('cancel', true, 'class-other-button class-botao-margin', 'block', 'Cancelar', );
        this.toolbarService.alterarStatus('download', true, 'Download', () => this.export());
        this.toolbarService.replace('print', true, 'class-first-button', 'print', 'Imprimir', );
        this.toolbarService.replace('remove', true, 'class-remove-button', 'delete', 'Excluir', );
        this.toolbarService.replace('edit', true, 'class-edit-button', 'edit', 'Editar', );
        this.toolbarService.replace('add', true, 'class-new-button', 'NOVO', 'Adicionar', );
      } else {
        // this.toolbarService.ocultar('check');
        // this.toolbarService.ocultar('info');
        // this.toolbarService.ocultar('cancel');
      }
    }
  get buttons(): Array<ToolbarButton> {
    return this.toolbarService.buttons;
  }
}
